// extracted by mini-css-extract-plugin
export default {"cuadro":"CuadroTiposTorneoOrganizadores_cuadro__O0i9y","botoneraOrganizadores":"CuadroTiposTorneoOrganizadores_botoneraOrganizadores__bDzuT"};